import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const DatePaid = {
  id: 'datePaid',
  displayName: <FormattedMessage {...messages.datePaid} />,
  type: OptionFormTypes.TYPE_ORDER_DATE_COMPARISON,
  filterValue: 'PaidDateTime',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON, criteriaInformations);
  },
};
